import api from './api';
import { RiskGroupDto } from '../models/medicalCheckups/riskGroupDto';
import { AppResponse } from '../models/common/app-response';
import { RiskGroupFilter } from '../models/analytics/riskGroupFilter';
import { DirectionsDriverDto, DirectionsFilter } from '../models/analytics/directions/directionsModels';
import { PaginatedResponse } from '../models/common/paginated-response';
import { MedicWorkloadFilter } from '../models/analytics/medicWorkloadFilter';
import { MedicWorkloadDto } from '../models/analytics/medicWorkloadDto';

class AnalyticsService {
  getByFilter(filter: RiskGroupFilter) {
    return api.post<AppResponse<RiskGroupDto>>('/api/v1/analytics/risk-group', filter);
  }

  getDirections(filter: DirectionsFilter) {
    return api.post<AppResponse<PaginatedResponse<DirectionsDriverDto>>>('/api/v1/analytics/directions', filter);
  }

  exportToExcel(data: RiskGroupDto) {
    return api.post('/api/v1/analytics/risk-group/export', data, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
  }

  getMedicWorkload(filter: MedicWorkloadFilter) {
    return api.post<AppResponse<MedicWorkloadDto>>('/api/v1/analytics/medic-workload', filter);
  }
}

export const analyticsService = new AnalyticsService(); 